
<template>

  <div v-if="availability" class="bg-white rounded p-4 m-3">
    <!--<div class="d-flex justify-content-between ">-->
    <div class="text-center"><img alt="Välkommen att chatta med oss" src="../../assets/chat.png"><br>
      <span style="line-height: 1.3;">
        <small style="font-size: 10px;"><i class="text-success fas fa-check-circle me-1"></i> ONLINE</small> <br>
        <span class="lh-1" style="font-size: 14px;">Välkommen att chatta med oss</span><br>
        
      </span>
    </div>
    <!--<i class="far fa-chevron-right text-muted"></i>-->
    <!--</div> -->
  </div>
<!-- <link rel="import" v-if="availability" :href="this.chatUrl"> -->
  <iframe style="position: absolute; top: 0;" v-if="availability" height="90%" width="100%" frameBorder="0" :src="this.chatUrl"></iframe>
  
    <div class="p-2 h-100 overflow-auto" v-else>
      <div class="bg-white p-3">
        <p>Chatten är offline just nu. Kontakta oss genom att fylla i formuläret.</p>
        <lime-form :form-id="site == 'gn' ? '9QYMMXAecQXyKzmkgLHE' : 'mMxVEIYmSyA2UMjivcMS'"></lime-form>
         <br><br>
          <small class="w-100 text-muted">Gävle Energi hanterar dina personuppgifter i enlighet med Dataskyddsförordningen. <a href="https://www.gavleenergi.se/gdpr" target="_blank">Läs mer här.</a><br>
              Tänk på att inte lämna ut integritetskänslig information i meddelande-/fritextfältet.</small>
      </div>
    </div>
  
  </template>
  
  <script>
  
  
  export default {
    props: { checkChatState: { type: Function }, site: {type: String}},
    data() {
      let availability = false;
      let chatUrl;
      if(this.site == "gn"){
         chatUrl = `https://www.gavlenet.se/inc/mitel/?site=${this.site}`;
      } else {
         chatUrl = `https://apps.gavleenergi.se/mitel/?site=${this.site}`;
      }

      return {
        chat: false,
        chatUrl,
        availability,
        displayChat: false,
      }
  
  
    },
  
  
   
    methods: {
  
      toggleContactForm() {
        this.displayContactForm = !this.displayContactForm
      },
  
      showWidget() {
        this.displayChat = true;
  
      },
  
      checkVisibility() {
  
        if (this.widgetState.visibility == "maximized" || this.widgetState.visibility == "minimized") { this.displayChat = false }
  
      },
  
      checkWidgetState() {
  
        fetch("https://gavchat.uc.tele2.se/StatAPI/api/customerstat/statprovider?tenant=3&servicegrp=CTEnergi")
              .then(res => res.json())
              .then(json => {
                //if (json.Status.Availability != 1 || json.Stats.ReadyAgents == 0) {
                  if (json.Status.Availability != 1) {
                    this.availability = false;
                  }
                  else {
                    this.availability = true;
                  }
                    console.log(this.availability)
                    this.checkChatState(this.availability)
              })
  
  
        
      }
  
  
  
  
    },
  
  
  
  mounted() {
     this.checkWidgetState()
  },
  
  
  
  
  }
  </script>
  
  <style scoped>
  
  </style>
  